import {Component, input, InputSignal} from '@angular/core';

@Component({
  selector: 'icon-filter',
  imports: [],
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" [attr.width]="size()" [attr.height]="size()"
         viewBox="0 0 24 24">
      <path fill="currentColor" fill-rule="evenodd"
            d="M3.5 7.25h3c.69 0 1.25.56 1.25 1.25v2c0 .69-.56 1.25-1.25 1.25h-3c-.69 0-1.25-.56-1.25-1.25v-2c0-.69.56-1.25 1.25-1.25ZM10.5 12.25h3c.69 0 1.25.56 1.25 1.25v2c0 .69-.56 1.25-1.25 1.25h-3c-.69 0-1.25-.56-1.25-1.25v-2c0-.69.56-1.25 1.25-1.25ZM17.5 9.25h3c.69 0 1.25.56 1.25 1.25v2c0 .69-.56 1.25-1.25 1.25h-3c-.69 0-1.25-.56-1.25-1.25v-2c0-.69.56-1.25 1.25-1.25Z"
            clip-rule="evenodd" />
      <path fill="currentColor" fill-rule="evenodd"
            d="M5 2.5a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1ZM5 10a1 1 0 0 1 1 1v9.5a1 1 0 1 1-2 0V11a1 1 0 0 1 1-1ZM19 2.5a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1Zm0 9.5a1 1 0 0 1 1 1v7.5a1 1 0 1 1-2 0V13a1 1 0 0 1 1-1ZM12 2.5a1 1 0 0 1 1 1V13a1 1 0 1 1-2 0V3.5a1 1 0 0 1 1-1Zm0 15a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1Z"
            clip-rule="evenodd" />
    </svg>
  `
})
export class IconFilterComponent {
  size: InputSignal<number> = input<number>(24);
}
